<template>
  <section v-if="info && info.isPublic" class="intro-section" id="gioi-thieu">
    <div class="intro-container">
      <div class="intro-grid">
        <!-- Left Column: Image / Slider -->
        <div class="intro-image-col">
          <div class="image-wrapper">

            <!-- Trường hợp 1: Có nhiều hơn 1 hình ảnh -> Hiển thị Slider chạy ảnh động -->
            <VueSlickCarousel :key="info.hinhAnh.length" v-if="info.hinhAnh && info.hinhAnh.length > 1" v-bind="carouselSettings">
              <div v-for="(img, idx) in info.hinhAnh" :key="idx" class="slide-item">
                <img :src="getImageUrl(img)" alt="Festival atmosphere" class="intro-img" />
              </div>
            </VueSlickCarousel>

            <!-- Trường hợp 2: Chỉ có duy nhất 1 hình ảnh -> Hiển thị ảnh tĩnh thông thường để tối ưu hiệu năng -->
            <img v-else-if="info.hinhAnh && info.hinhAnh.length === 1" :src="getImageUrl(info.hinhAnh[0])"
              alt="Festival atmosphere" class="intro-img" />

            <!-- Trường hợp 3: Không có hình ảnh nào -> Hiển thị ảnh fallback mặc định của Ban tổ chức -->
            <img v-else alt="Festival atmosphere" class="intro-img"
              src="https://lh3.googleusercontent.com/aida-public/AB6AXuC9XfqSNCsMnQ27gONvM13yV_xgJsy_0Osg6FVbIIYIHVjWjCXAyvMgRwA4O52Nr1Vpx01nw7rPmglZO0okSPXo6XlDI5PKXP3b3eKy5Kkb_tVsNamQrX43k9PdRrHMGGoR8P1csTgdFZHQMqnJpmmV51QG-3gTMQJsmjhQbzO2wgQSQ8AJ3hZ1SZ-s-F-jmMgchztqI4fVwUNvu2I8zmbyrYlgHzKxYPvx_bO7232ItHR8VNB1hIpsExEJyfEJNa7ODOOGTiaASYuP" />
          </div>
          <div class="image-blur-bg"></div>
        </div>

        <!-- Right Column: Content -->
        <div class="intro-content-col">
          <div class="intro-header">
            <hr class="intro-line" />
            <span class="intro-subtitle">{{ $t('home.about.subtitle') || 'GIỚI THIỆU LỄ HỘI' }}</span>
          </div>
          <h2 class="intro-title">
            {{ getLangValue('tenGoi') }}
          </h2>
          <p class="intro-desc highlight-theme">
            <strong>{{ $t('home.about.theme') || 'Chủ đề' }}:</strong> {{ getLangValue('chuDe') }}
          </p>

          <div class="info-grid">
            <div class="info-card">
              <div class="info-icon-wrapper">
                <span class="material-symbols-outlined">calendar_month</span>
              </div>
              <div class="info-text">
                <span class="info-label">{{ $t('home.about.time') || 'Thời gian' }}</span>
                <span class="info-value">{{ getLangValue('thoiGian') }}</span>
              </div>
            </div>

            <div class="info-card">
              <div class="info-icon-wrapper">
                <span class="material-symbols-outlined">groups</span>
              </div>
              <div class="info-text">
                <span class="info-label">{{ $t('home.about.scale') || 'Quy mô' }}</span>
                <span class="info-value">{{ getLangValue('quyMo') }}</span>
              </div>
            </div>

            <div class="info-card full-width">
              <div class="info-icon-wrapper">
                <span class="material-symbols-outlined">location_on</span>
              </div>
              <div class="info-text">
                <span class="info-label">{{ $t('home.about.location') || 'Địa điểm' }}</span>
                <span class="info-value">{{ getLangValue('diaDiem') }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { siteInfoModel } from "@/models/profession/siteInfo/siteInfoModel";
import VueSlickCarousel from "vue-slick-carousel";

// Đảm bảo import CSS của slick-carousel trong dự án nếu cần thiết
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
  name: "SiteInfo",
  components: {
    VueSlickCarousel,
  },
  data() {
    return {
      info: siteInfoModel.baseJson(),
      apiView: process.env.VUE_APP_API_URL + 'filesminio/view/',
      carouselSettings: {
        dots: true,
        infinite: true,
        speed: 800,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        arrows: false,
        fade: true
      }
    };
  },
  methods: {
    getLangValue(fieldName) {
      if (!this.info) return "";
      const currentLocale = this.$i18n ? this.$i18n.locale : "vi";
      if (currentLocale === "en") {
        const enField = `${fieldName}En`;
        return this.info[enField] || this.info[fieldName] || "";
      }
      return this.info[fieldName] || "";
    },
    async getSiteInfo() {
      await this.$store
        .dispatch("profession/infoSite/infoSiteStore/getSiteInfo")
        .then((res) => {
          this.info = siteInfoModel.fromJson(res.data);
        });
    },
    // 🌐 ĐỒNG BỘ HÓA PHƯƠNG THỨC LẤY URL HÌNH ẢNH CHUẨN MINIO
    getImageUrl(file) {
      if (!file) return "";
      if (file.fileId) return this.apiView + file.fileId;
      return file.path || "";
    },
  },
  mounted() {
    this.getSiteInfo();
  },
};
</script>

<style scoped>
.intro-section {
  padding: 80px 0;
  background-color: var(--color-public-surface, #f7fbf0);
}

.intro-container {
  max-width: var(--container-max, 1280px);
  margin: 0 auto;
  padding: 0 var(--spacing-gutter, 24px);
}

.intro-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--spacing-gutter, 24px);
  align-items: center;
}

@media (min-width: 768px) {
  .intro-grid {
    grid-template-columns: 5fr 7fr;
  }
}

.intro-image-col {
  position: relative;
  min-width: 0;
  overflow: hidden;
  max-width: 450px;
  width: 100%;
  margin: 0 auto;
}

@media (min-width: 768px) {
  .intro-image-col {
    max-width: none;
    margin: 0;
  }
}

.image-wrapper {
  position: relative;
  z-index: 10;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  background-color: var(--surface-container-low, #f1f5eb);
  width: 100%;
}

.intro-img {
  width: 100%;
  aspect-ratio: 3 / 4;
  object-fit: cover;
  display: block;
}

.image-blur-bg {
  position: absolute;
  bottom: -40px;
  right: -40px;
  width: 192px;
  height: 192px;
  background-color: rgba(46, 125, 50, 0.2);
  border-radius: 50%;
  filter: blur(48px);
  z-index: 0;
}

.intro-content-col {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

@media (min-width: 768px) {
  .intro-content-col {
    padding-left: 32px;
  }
}

.intro-header {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--color-public-primary, #0d631b);
}

.intro-line {
  width: 48px;
  border: 0;
  border-top: 2px solid var(--color-public-primary, #0d631b);
  margin: 0;
}

.intro-subtitle {
  font-family: var(--font-body, "Inter");
  font-size: var(--text-label-lg-size, 14px);
  font-weight: 600;
  letter-spacing: 0.05em;
}

.intro-title {
  font-family: var(--font-heading, "Montserrat");
  font-size: var(--text-headline-md-size, 32px);
  font-weight: 600;
  color: var(--color-public-text-head, #1B5E20);
  line-height: 1.3;
  margin: 0;
  text-align: left;
}

.intro-desc {
  font-family: var(--font-body, "Inter");
  font-size: var(--text-body-md-size, 16px);
  color: var(--color-public-text-body, #40493d);
  line-height: 1.6;
  margin: 0;
  text-align: left;
}

.highlight-theme {
  font-size: 1.1rem;
  color: var(--color-public-primary, #0d631b);
  background: #f1f5eb;
  padding: 12px 16px;
  border-left: 4px solid var(--color-public-primary, #0d631b);
  border-radius: 4px 8px 8px 4px;
  margin-bottom: 8px;
}

.info-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  margin-top: 8px;
}

@media (min-width: 640px) {
  .info-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .info-card.full-width {
    grid-column: span 2;
  }
}

.info-card {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background-color: #ffffff;
  padding: 16px;
  border-radius: 12px;
  border: 1px solid var(--surface-dim, #d7dbd2);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.info-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.info-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background-color: #e8f5e9;
  color: var(--color-public-primary, #0d631b);
  border-radius: 12px;
  flex-shrink: 0;
}

.info-icon-wrapper span {
  font-size: 24px;
}

.info-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-align: left;
}

.info-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--color-public-text-body, #6b7280);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.info-value {
  font-size: 1rem;
  color: var(--color-public-text-head, #1f2937);
  font-weight: 500;
  line-height: 1.4;
}

@media (max-width: 576px) {
  .intro-img {
    height: 280px;
  }

  .intro-title {
    font-size: 24px;
  }
}

::v-deep .slick-dots {
  bottom: 15px;
}

::v-deep .slick-dots li button:before {
  color: #ffffff;
  font-size: 8px;
  opacity: 0.6;
}

::v-deep .slick-dots li.slick-active button:before {
  color: var(--color-public-primary, #0d631b);
  opacity: 1;
}

.slide-item {
  outline: none;
}
</style>